import {KTSVG} from '../../../_metronic/helpers'
import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import { useAllproductsandtypes,useAllproductunits,  useAllproductcategories, useAddproducts} from '../../contextProviders/Atomqueryprovider'
import {useAuth} from '../../../app/modules/auth'
import CreatableSelect from 'react-select/creatable'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import Select from 'react-select'
import { useSelectStyles } from '../../helpers/useSelectStyles'
import EditableDiv from '../../helpers/components/EditableDiv'


type Props = {
  show: boolean
  handleClose: () => void
 
}

const initialValues = {
  product_name: "",
  units_in_stock: 0,
  unit_buying_price: 0,
  reorder_level: 0,
  product_category_id: "",
  product_unit_id: "",
  unit_selling_price: 0,
  product_description: "",
  product_division:1,
  product_image: ""

}
const API_URL = process.env.REACT_APP_API_URL
const FILE_SIZE = 1000000;
const SUPPORTED_FORMATS = [
  "image/png"
];
const productSchema = Yup.object().shape({
  product_name: Yup.string()
  .required('A product name is required'),
  units_in_stock: Yup.number()
  .required('Stock units are required'),
  unit_buying_price: Yup.number()
  .required('Unit buying price is required'),
  reorder_level: Yup.number()
  .required('Reorder level is required'),
  product_category_id: Yup.string()
  .required('Product category is required'),
  product_unit_id: Yup.string().required('Product unit is required'),
  unit_selling_price: Yup.number()
  .required('Unit selling price is required'),
  product_image: Yup.mixed().required('A product picture is required').test(
    "fileSize",
          "File too large",
          value => value && value.size <= FILE_SIZE
  ).test(
    "fileFormat",
    "Unsupported Format",
    value => value && SUPPORTED_FORMATS.includes(value.type)
  ),
  product_description: Yup.string().required('Product description is required'),
  product_division: Yup.number().required('A product division is required'),
})


export const Addproduct: React.FC<Props> = ({show, handleClose}) => {
  const [loading, setLoading] = useState(false)
 
 
  const [products_unit, setProducts_unit] = useState<any>([])
  const [loadedProducts_category, setLoadedProducts_category] = useState(false)
  const [products_category, setProducts_category] = useState<any>([])
  const [productadded, setProductadded] = useState<any>({})
  const [submittingready, setSubmittingready] = useState<boolean>(false)

  const {currentUser} = useAuth()
  const getFormData: any = <T extends Record<string, any>>(obj: T): FormData =>
  Object.entries(obj).reduce((formData: FormData, [key, value]) => {
    if (value instanceof FileList) {
      for (let i = 0; i < value.length; i++) {
        formData.append(key, value[i]);
      }
    } else {
      formData.append(key, value);
    }
    return formData;
  }, new FormData());
 
  const {
    mutateAsync: addproductsmutateAsync
  } =  useAddproducts(getFormData(productadded))

  const product_division =[{value: 0.25, label: 0.25},
    {value: 0.5, label: 0.5},
    {value: 0.75, label: 0.75},
    {value: 1, label: 1}]

  const formik = useFormik({
    initialValues,
    validationSchema: productSchema,
    validateOnBlur: true,
    onSubmit: async (values, {setStatus, setSubmitting, resetForm}) => {
    
       setLoading(true)
       
        setProductadded({
          user_id: currentUser?.user_id,
          discount_percentage: 0,
          product_name: values.product_name,
          units_in_stock: values.units_in_stock,
          unit_buying_price: values.unit_buying_price,
          reorder_level: values.reorder_level,
          product_category_id: values.product_category_id,
          product_unit_id: values.product_unit_id,
          unit_selling_price: values.unit_selling_price,
          product_description: values.product_description,
          product_image: values.product_image,
          product_division: values.product_division  
  
        });
        setSubmittingready(true)
     
     
    },
  })

  

  const {
    isLoading: allproductsandtypesloading,
    isSuccess: allproductsandtypessuccess,
    data: allproductsandtypesdata,
    status: allproductsandtypesstatus,
    refetch: allproductsandtypesrefetch
  } = useAllproductsandtypes()

  const {
    isLoading: allproductcategoriesloading,
    isSuccess: allproductcategoriessuccess,
    data: allproductcategoriesdata,
    status: allproductcategoriesstatus,
    refetch: allproductcategoriesrefetch
  } = useAllproductcategories()

  const {
    isLoading: allproductunitsloading,
    isSuccess: allproductunitssuccess,
    data: allproductunitsdata,
    status: allproductunitsstatus,
    refetch: allproductunitsrefetch
  } = useAllproductunits()

  
  useEffect(()=>{

    if(submittingready && productadded){
  
     
      addproductsmutateAsync(getFormData(productadded), {
        onSuccess: () =>{
      
          setLoading(false)
          formik.resetForm({})
          formik.setSubmitting(false)
          setProductadded({})
          setSubmittingready(false)
          handleClose()
  
        },
        onError(error, variables, context) {
          formik.setStatus('The product details are incorrect')
          formik.setSubmitting(false)
          setLoading(false)
        },
  
      })
      
    }
  
    }, [submittingready])
  

  

  const options = allproductsandtypessuccess && allproductsandtypesdata?.data.map((val: any, index: any) => {
    return {
      value: val.product_name,
      label: val.product_name,
      units_in_stock: val.units_in_stock,
      unit_buying_price: val.unit_buying_price,
      product_category_id: val.product_category_id,
      product_unit_id: val.product_unit_id,
      product_id: val.product_id,
      unit_selling_price: val.unit_selling_price,
    }
  })

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>Add Product</h3>

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form
            id='kt_modal_add_product_form'
            noValidate
            className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
            onSubmit={formik.handleSubmit}
          >
            {/* begin::Input group */}
            <div className='fv-row mb-7'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Add Product <span className='text-primary'>(Must be Unique)</span></label>
              {/* end::Label */}

              <CreatableSelect
                options={options}
                placeholder={"Create new product name ..."}
                styles={useSelectStyles()}
                isDisabled={false}
                isLoading={allproductsandtypesloading}
                isClearable={true}
                isSearchable={true}
                onChange={(selectedOption: any) =>
                  formik.setFieldValue('product_name', selectedOption.value)
                }
              />

              {formik.touched.product_name && formik.errors.product_name && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.product_name}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Input group */}

            {/* begin::Input group */}

            <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Units in Stock</label>
                  <input
                    placeholder='0'
                    type='number'
                    {...formik.getFieldProps('units_in_stock')}
                    autoComplete='off'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid': formik.touched.units_in_stock && formik.errors.units_in_stock,
                      },
                      {
                        'is-valid': formik.touched.units_in_stock && !formik.errors.units_in_stock,
                      }
                    )}
                  />
                  {formik.touched.units_in_stock && formik.errors.units_in_stock && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.units_in_stock}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Unit Buying Price</label>
                  <input
                    type='number'
                    autoComplete='off'
                    placeholder='0.00'
                    {...formik.getFieldProps('unit_buying_price')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.unit_buying_price && formik.errors.unit_buying_price,
                      },
                      {
                        'is-valid':
                          formik.touched.unit_buying_price && !formik.errors.unit_buying_price,
                      }
                    )}
                  />
                  {formik.touched.unit_buying_price && formik.errors.unit_buying_price && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.unit_buying_price}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
            </div>

            {/* end::Input group */}

            {/* begin::Input group */}

            <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Reorder Level</label>
                  <input
                    placeholder='0'
                    type='number'
                    autoComplete='off'
                    {...formik.getFieldProps('reorder_level')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid': formik.touched.reorder_level && formik.errors.reorder_level,
                      },
                      {
                        'is-valid': formik.touched.reorder_level && !formik.errors.reorder_level,
                      }
                    )}
                  />
                  {formik.touched.reorder_level && formik.errors.reorder_level && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.reorder_level}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Product Category</label>
                  <Select
                    styles={useSelectStyles()}
                    isLoading={allproductcategoriesloading}
                    isClearable={true}
                    isSearchable={true}
                    placeholder={"Select product category ..."}
                    options={allproductcategoriessuccess && allproductcategoriesdata?.data.map((x: any) => {
                      return {value: x.product_category_id, label: x.category_name}
                    })}
                    onChange={(selectedOption: any) =>
                      formik.setFieldValue('product_category_id', selectedOption.value)
                    }
                  />
                  {formik.touched.product_category_id && formik.errors.product_category_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.product_category_id}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
            </div>

            {/* end::Input group */}

            {/* begin::Input group */}

            <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Product Unit</label>
                  <Select
                    styles={useSelectStyles()}
                    isLoading={allproductunitsloading}
                    isClearable={true}
                    isSearchable={true}
                    placeholder={"Select product unit ..."}
                    options={allproductunitssuccess &&  allproductunitsdata?.data.map((x: any) => {
                      return {value: x.product_unit_id, label: x.unit_name}
                    })}
                    onChange={(selectedOption: any) =>
                      formik.setFieldValue('product_unit_id', selectedOption.value)
                    }
                  />
                  {formik.touched.product_unit_id && formik.errors.product_unit_id && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.product_unit_id}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Unit Selling Price</label>
                  <input
                    type='number'
                    autoComplete='off'
                    placeholder='0.00'
                    {...formik.getFieldProps('unit_selling_price')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid':
                          formik.touched.unit_selling_price && formik.errors.unit_selling_price,
                      },
                      {
                        'is-valid':
                          formik.touched.unit_selling_price && !formik.errors.unit_selling_price,
                      }
                    )}
                  />
                  {formik.touched.unit_selling_price && formik.errors.unit_selling_price && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.unit_selling_price}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
            </div>

            {/* end::Input group */}
             {/* begin::Input group */}

             <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Product Division</label>
                  <Select
                    styles={useSelectStyles()}
                    isClearable={true}
                    isSearchable={true}
                    options={product_division}
                    placeholder={"Select product division ..."}
                    onChange={(selectedOption: any) =>
                      formik.setFieldValue('product_division', selectedOption.value)
                    }
                  />
                  {formik.touched.product_division && formik.errors.product_division && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.product_division}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
              <div className='col-xl-6'>
                {/* begin::Form group second_name */}
                <div className='fv-row mb-7'>
                  <label className='required fw-bold fs-6 mb-2'>Product Image Link</label>
                  <input
                    id='product_image'
                    type='file'
                    accept='image/*'
                    name='product_image'
                    onChange={(event: any) => {
                      formik.setFieldValue('product_image', event.currentTarget.files[0])
                    }}
                  
                    className={'form-control form-control-lg form-control-solid text-primary'}
                  />
                  {formik.touched.product_image && formik.errors.product_image && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.product_image}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
            </div>

            {/* end::Input group */}

            {/* begin::Input group */}
            <div className='fv-row mb-7'>
              {/* begin::Label */}
              <label className='required fw-bold fs-6 mb-2'>Product Description</label>
              {/* end::Label */}

              <div className='d-flex flex-column flex-grow-1'>
                <div className='d-flex flex-wrap'>
                  <div className='col-12'>
                 
                     <EditableDiv
                      placeholder='Add a description here ...'
                      initialContent=''
                      onChange={(x: any)=> formik.setFieldValue('product_description', x)}
                      className={clsx(
                        'form-control form-control-lg form-control-solid',
                        {
                          'is-invalid':
                            formik.touched.product_description && formik.errors.product_description,
                        },
                        {
                          'is-valid':
                            formik.touched.product_description &&
                            !formik.errors.product_description,
                        }
                      )}
                      
                   /> 

                    {formik.touched.product_description && formik.errors.product_description && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                          <span role='alert'>{formik.errors.product_description}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* end::Input group */}
          </form>
        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={handleClose}>
            Cancel
          </button>

          <button
            type='submit'
            form='kt_modal_add_product_form'
            className='btn btn-success'
            disabled={formik.isSubmitting || !formik.isValid || !formik.dirty }
          >
            {!loading && <span className='indicator-label'>Add Product</span>}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  )
}
